import styled from '@emotion/styled';
import React, { PropsWithChildren, useCallback } from 'react';
import { useDropzone } from 'react-dropzone';

const Frame = styled.div({
    width: '100%', height: '100%',
});

export type FileDropAreaProps = {
    onFiles: (files: File[]) => void;
};

export function FileDropArea(props: PropsWithChildren<FileDropAreaProps>) {
    const { onFiles, children } = props;

    const onDrop = useCallback(
        (acceptedFiles: File[]) => {
            onFiles(acceptedFiles);
        },
        [onFiles]
    );

    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop,
        noClick: true,
    });

    return (
        <Frame {...getRootProps()}>
            {isDragActive ? <input {...getInputProps()} /> : <></>}
            {children}
        </Frame>
    );
}
